module.exports = __webpack_public_path__ + "img/addresses.d4a0405b.svg";